export class IamCredentialsProvider {
    credentials;
    constructor(credentials) {
        this.credentials = credentials;
    }
    getCredentials() {
        return () => Promise.resolve({
            accessKeyId: this.credentials.accessKey,
            secretAccessKey: this.credentials.secretKey,
        });
    }
    stop() { }
}
